import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';

function QbInvoiceNoCell({ colSpan, dataItem, field, className, ariaColumnIndex, style }) {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected="false"
      style={style}>
      {dataItem[field] ? (
        <div className="table__contents--multi-val">
          <span className="--qbo">
            <img
              height="16"
              width="16"
              alt={translate('quick_books', { namespace: 'quick_books.generic' })}
              src="/qbo.svg"
              className="custom-icon--qbo"
              title={translate('quick_books', { namespace: 'quick_books.generic' })}
            />
            {dataItem[field]}
          </span>
        </div>
      ) : (
        <span>--</span>
      )}
    </td>
  );
}

QbInvoiceNoCell.propTypes = {
  colSpan: PropTypes.number.isRequired,
  dataItem: PropTypes.shape({
    qboInvoiceId: PropTypes.string
  }).isRequired,
  field: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  ariaColumnIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};

export default QbInvoiceNoCell;
